import { Conexion } from "../../Config/Coneccion";
class NotasCon extends Conexion {
    constructor(clase: string) {
        super();
        this.clase = clase;
    }
}
export default function conNotasCD(clase: string) {
    return new NotasCon(clase);
}